'use client';

import { c as _c } from "react/compiler-runtime";
import AnimateLines from '@components/animate-lines/AnimateLines';
import BackgroundImage from '@components/background-image/BackgroundImage';
import Arch1 from '@images/renders/architecture_images/arch-main.webp';
import { isLoadingSelector } from '@lib/store/slices/ComponentsSlice';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styles from '../Architecture.module.scss';
const ArchitectureBackgroundAnimation = () => {
  const $ = _c(10);
  const [toggle, setToggle] = useState(false);
  const isLoading = useSelector(isLoadingSelector);
  let t0;
  let t1;
  if ($[0] !== isLoading) {
    t0 = () => {
      if (isLoading) {
        setTimeout(() => {
          setToggle(true);
        }, 200);
      }
    };
    t1 = [isLoading];
    $[0] = isLoading;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== toggle) {
    t2 = <BackgroundImage first={false} toggle={toggle} className={styles.bg} src={Arch1} src375={Arch1} name="arch_1" imagePlug={Arch1} />;
    $[3] = toggle;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== toggle) {
    t3 = <div className={styles.firstScreenSvg}><AnimateLines id="vector_arch_1" className={styles.svgClass} toggle={toggle} /></div>;
    $[5] = toggle;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default ArchitectureBackgroundAnimation;